import distanceToLocalStr from '../../utils/distanceToLocal';
import { searchRadiuses } from '../fapApp.config';

const fapResultsListFilters = [
  {
    name: 'field_geofield',
    label: Drupal.t('Location'),
    type: 'geolocation',
    options: searchRadiuses.map((distance) => {
      return {
        label: distanceToLocalStr(distance, true),
        value: distance,
      };
    }),
    wrapInAccordion: true,
  },
  {
    name: 'field_agent_services',
    label: Drupal.t('Additional Services'),
    type: 'checkboxes',
    viewAllButton: true,
    options: [],
    wrapInAccordion: true,
    isFacet: true,
    forceTabletViewAll: true,
  },
  {
    name: 'certifications',
    label: Drupal.t('Credentials'),
    type: 'checkboxes',
    viewAllButton: true,
    options: [],
    wrapInAccordion: true,
    isFacet: true,
    forceTabletViewAll: true,
  },
];

export default fapResultsListFilters;
